import { FC } from 'react'
import Placeholder from '../Placeholder'
import {
  MediaItem,
  MediaItemProps,
  SelectItemProps,
} from 'components/MediaItem'
import useSingleMedia from '../hooks/useSingleMedia'
import { ContentOverlayProps } from 'components/SensitiveContentOverlay'
import { MediaUpload } from '@wellesley/uploads'

type SingleMediaProps = {
  upload: MediaUpload
  containerWidth: number
  onClick: (props: SelectItemProps) => void
  isReply?: boolean
  isSmallPreview?: boolean
} & ContentOverlayProps &
  Pick<MediaItemProps, 'removeMedia' | 'updateMedia'>

const SingleMedia: FC<SingleMediaProps> = ({
  upload,
  onClick,
  isReply,
  isSmallPreview,
  containerWidth,
  updateMedia,
  ...overlayProps
}) => {
  const sizes = useSingleMedia({ upload, isReply, containerWidth })

  return (
    <Placeholder
      testId="singleMediaItem"
      className="relative w-fit max-w-full"
      {...(!isSmallPreview && { ...sizes })}
    >
      <MediaItem
        sizes={sizes}
        upload={upload}
        isSmallPreview={isSmallPreview}
        onClick={onClick}
        containerWidth={containerWidth}
        canPlayInline
        updateMedia={updateMedia}
        {...overlayProps}
      />
    </Placeholder>
  )
}

export default SingleMedia
